export const Logo = ({ size = 40, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="29" fill="none" stroke="#D4AF37" strokeWidth="1.6" />
    <circle cx="32" cy="32" r="23" fill="none" stroke="#D4AF37" strokeWidth="0.8" strokeDasharray="2 3" />
    <path d="M17 22 L24 44 L32 29 L40 44 L47 22" fill="none" stroke="#F3E5AB" strokeWidth="3"
      strokeLinejoin="round" strokeLinecap="round" />
    <circle cx="32" cy="12.5" r="2" fill="#D4AF37" />
    <circle cx="32" cy="51.5" r="1.2" fill="#D4AF37" />
  </svg>
);

export const Seal = ({ className = "" }) => (
  <svg viewBox="0 0 400 400" className={className} aria-hidden="true">
    <defs>
      <path id="ring" d="M200,200 m-160,0 a160,160 0 1,1 320,0 a160,160 0 1,1 -320,0" />
    </defs>
    <circle cx="200" cy="200" r="190" fill="none" stroke="rgba(212,175,55,.35)" strokeWidth="1" />
    <circle cx="200" cy="200" r="175" fill="none" stroke="rgba(212,175,55,.5)" strokeWidth="0.6" strokeDasharray="1 6" />
    <text fill="rgba(243,229,171,.75)" fontSize="13" letterSpacing="6" fontFamily="JetBrains Mono, monospace">
      <textPath href="#ring">RETOUR D'AFFECTION · RÉUSSITE · PROTECTION · DISCRÉTION · AMOUR ·</textPath>
    </text>
    <polygon points="200,70 230,170 330,200 230,230 200,330 170,230 70,200 170,170"
      fill="none" stroke="rgba(212,175,55,.45)" strokeWidth="1" />
    <polygon points="200,110 262,138 290,200 262,262 200,290 138,262 110,200 138,138"
      fill="none" stroke="rgba(212,175,55,.25)" strokeWidth="1" />
  </svg>
);
